import { UsuarioTipoPermissao } from '@app/models/util/usuario-tipo-permissao';

import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { UsuarioTipo } from '@app/models/usuario-tipo.model';


@Injectable()
export class UsuarioTipoService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }

  gravar(usuarioTipo: UsuarioTipo, usuarioTipoPermissao: UsuarioTipoPermissao[] = []): Observable<any> {
    usuarioTipo.Permissoes = usuarioTipoPermissao;
    return this.http.post<any>(this.URL_API + 'configuracoes/usuarioTipo', usuarioTipo).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `configuracoes/usuarioTipo/${id}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  obterPorId(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `configuracoes/usuarioTipo/${id}`);
  }

  obterPesquisa(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http.get<any>(
      this.URL_API + `configuracoes/usuarioTipo/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] } }
    );
  }

  obterOpcoesDeMenu(usuarioTipoId: number, semSubMenus: boolean, formulario: boolean = false): Observable<any> {
    return this.http.get<any>(this.URL_API + `configuracoes/usuarioTipo/opcoesDeMenu/?usuarioTipoId=${usuarioTipoId}&semSubMenus=${semSubMenus}&formulario=${formulario}`);
  }

  obterPermissoes(usuarioTipoId: number): Observable<any> {
    return this.http.get<any>(this.URL_CACHE + `configuracoes/usuarioTipo/Permissoes/?usuarioTipoId=${usuarioTipoId}`).pipe(
      catchError(
        () => this.http.get<any>(this.URL_API + `configuracoes/usuarioTipo/Permissoes/?usuarioTipoId=${usuarioTipoId}`).pipe(
                        catchError((error: any) => observableThrowError(error.json)))
                ));
  }
  //usuarioTipoPermissao
  MenuUsuarioTipoPermissoes(usuarioTipoId: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `configuracoes/usuarioTipo/obterPermissoes/?usuarioTipoId=${usuarioTipoId}`);
  }
  verificaPermissaoUsuario(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/usuarioTipo/verificaPermissao`);
  }
}
